import { defineStore } from '@sunrise/pinia'

import { MailAgentStore } from './mailAgentStoreModule.interface'

export const useMailAgentStore = defineStore('mailAgent', {
    state: (): MailAgentStore => ({
        tags: {
            locationName: '',
            estateType: '',
            searchRadius: '',
            priceRange: '',
            areaRange: '',
            roomRange: '',
            furnishing: '',
            equipment: [],
            category: [],
        },
    }),
    actions: {
        resetFilterTags() {
            this.tags.priceRange = ''
            this.tags.areaRange = ''
            this.tags.roomRange = ''
            this.tags.furnishing = ''
            this.tags.equipment = []
            this.tags.category = []
            this.tags.searchRadius = 'Umkreis 20km'
        },
    },
    getters: {
        tagsAsArray(state): string[] {
            /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
            return Object.entries(state.tags).reduce((acc: string[], [_, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((item) => acc.push(item))
                } else if (value) {
                    acc.push(value)
                }
                return acc
            }, [])
        },
    },
})
